module.exports = __webpack_public_path__ + "static/media/logo.2853bf65.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 583
// module chunks = 0